var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dash-text__16 dash-text__500 base_menu"},_vm._l((_vm._modules),function(item,index){return _c('router-link',{key:item.id,staticClass:"demo__Router demo__font--16 demo__weight--600",class:{
      'demo__Router--active': _vm.module === item.id && _vm.$route.path !== '/',
    },style:({
      marginRight: index !== _vm._modules.length - 1 ? '100px' : 0,
    }),attrs:{"slot":"tab","animated":true,"to":item.url},slot:"tab"},[_c('span',{staticClass:"v-a-m"},[_vm._v(_vm._s(_vm.$t(item.id)))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }